<template>
  <div>
    <tk-text-box
      :theme="theme"
      :placeholder="placeholder"
      :value="condition.departureDateAsIsoFormat || ''"
      :size="size"
      :icon="icon"
      :put-icon-outside="putIconOutside"
      :icon-color="iconColor"
      :icon-separator="iconSeparator"
      cursor="pointer"
      :disabled="disabled"
      readonly
      @click="isModalOpened = true"
    />
    <tk-general-purpose-modal
      v-if="isModalOpened"
      no-show-header
      @close="isModalOpened = false"
    >
      <div class="departureDatePicker_calendarModalHeader">
        出発日を選択
        <span
          class="departureDatePicker_calendarModalHeaderCrossMarkArea"
          @click="isModalOpened = false"
        >
          <tk-cross-mark />
        </span>
      </div>
      <tk-date-picker
        :allow-undecided-date="true"
        :start-date="condition.departureDateAsIsoFormat || ''"
        :max-date="maxDate"
        :min-date="minDate"
        :ymd-format="'yyyy-MM-dd'"
        :selectable-nights="selectableDurations"
        :nights="condition.durationFrom"
        @confirmed="confirmDate"
        @month-selected="selectMonth"
        @nights-selected="updateDuration"
      />
    </tk-general-purpose-modal>
  </div>
</template>

<script>
import { addDays, addMonths } from 'date-fns'
import { TkCrossMark, TkDatePicker, TkGeneralPurposeModal, TkTextBox } from '@ota-frontend/ui'
import { SearchCondition } from '@/models'

export default {
  name: 'DepartureDatePicker',

  components: { TkCrossMark, TkDatePicker, TkGeneralPurposeModal, TkTextBox },

  model: {
    prop: 'condition',  // withDeparturePlaces で departurePlaces を付与したものが必要
    event: 'selected',
  },

  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
    minDate: {
      type: Date,
      default: () => addDays(new Date(), 3),
    },
    maxDate: {
      type: Date,
      default: () => addMonths(new Date(), 20),
    },
    theme: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'normal',  // normal, large, x-large, xx-large, xxx-large
    },
    placeholder: {
      type: String,
      default: '出発日を選択',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'place',
    },
    putIconOutside: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconSeparator: {
      type: String,
      default: '',
    },
    selectableDurations: {
      type: Array, // of integer
      default: () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    },
  },

  data: () => ({
    isModalOpened: false,
  }),

  methods: {
    // startingDateはDateオブジェクト、startingYearMonth は yyyy-mm の文字列
    confirmDate({ startingDate, startingYearMonth }) {
      const [selectedYearMonth, selectedDate] = startingDate
        ? [
          `${startingDate.getFullYear()}-${String(startingDate.getMonth() + 1).padStart(2, '0')}`,
          String(startingDate.getDate()).padStart(2, '0') || '',
        ]
        // 日付未指定のまま検索条件を変更しなかった場合
        : [
          startingYearMonth,
          '',
        ]

      const updated = (() => {
        if (selectedYearMonth && selectedDate) return this.condition.updateDepartureDate(`${selectedYearMonth}-${selectedDate}`)
        if (selectedYearMonth) return this.condition.updateDepartureMonth(selectedYearMonth)
        return this.condition.unsetDepartureDate()
      })()
      this.$emit('selected', updated)

      this.isModalOpened = false
    },
    selectMonth(yearMonth) {
      this.$emit('selected', this.condition.updateDepartureMonth(yearMonth))
      this.isModalOpened = false
    },
    updateDuration(duration) {
      const asNumber = duration ? Number(duration) : undefined
      this.$emit('selected', this.condition.update({
        [SearchCondition.PARAMS.DURATION_FROM]: asNumber,
        [SearchCondition.PARAMS.DURATION_TO]: asNumber,
      }))
    },
  },
}
</script>

<style scoped lang="scss">
.departureDatePicker_calendarModalHeader {
  font-size: 14px;
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic",
    Osaka, sans-serif;
  position: relative;
  width: 100%;
  margin: auto;
  padding: 15px 0;
  color: #fff;
  background: #f9423a;
  text-align: center;
}

.departureDatePicker_calendarModalHeaderCrossMarkArea {
  display: flex;
  width: 40px;
  height: 80%;
  background: none;
  border-radius: 0;
  cursor: pointer;
  float: none;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(calc(-50% + -1px));
}
.departureDatePicker_calendarModalHeaderCrossMarkArea i {
  position: absolute;
  top: 14px;
  left: 11px
}
</style>
